import React from 'react';
import { faFacebook, faInstagram, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link, Links } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#166013] text-white py-8">
      {/* 313232 */}

        {/* Footer Content */}
        <div className="flex flex-col gap-12 md:flex-row justify-around">
          {/* Logo and Description Section */}
          <div className="flex flex-col items-center ">
            <Link to="/">
            <img 
              src="/images/logonew2.png" 
              alt="Company Logo" 
              className="w-32 h-32 lg:w-72 lg:h-48 " 
            /></Link>
            <p className="text-center text-white max-w-md text-lg">
              DSGO Solutions Your trusted partner in innovative refrigeration solutions for businesses of all sizes.
            </p>
          </div>

          {/* Business Areas Section */}
          <div className="text-center sm:text-left">
            <h3 className="text-xl font-bold mb-4">Business Areas</h3>
            <ul className="space-y-2 text-white">
            <Link to="/cofee"><li className='pt-1'>Coffee Shop</li></Link>
            <Link to="/bakerypastry"> <li className='pt-1'>Bakery & Pastry</li></Link>
            <Link to="/takeaway">  <li className='pt-1'>Take-Away</li></Link>
              <Link to="/butchery"> <li className='pt-1'>Butchery & Charcuterie</li></Link>
             <Link to="/supermarket">  <li className='pt-1'>Supermarket & C-Stores</li></Link>
             <Link to="/sushi">  <li className='pt-1'>Sushi</li></Link>
             <Link to="/choclote">  <li className='pt-1'>Chocolate</li></Link>
             <Link to="/icecream">  <li className='pt-1'>Ice Cream</li></Link>
             <Link to="/seafood">  <li className='pt-1'>Fish & Seafood</li></Link>
             <Link to="/restaurent">  <li className='pt-1'>Restaurant & Self-Service</li></Link>
             {/* <Link to="/bakerypastry">  <li>Professional Kitchens</li></Link> */}
            </ul>
          </div>

          

          <div className="text-center sm:text-left">
            <h3 className="text-xl font-bold mb-4">Models</h3>
            <ul className="space-y-2 text-white">
             <Link to="/display">  <li className='pt-1'>Display Cases</li></Link>
             <Link to="/multideck">  <li className='pt-1'>Multidecks</li></Link>
             <Link to="/islands">  <li className='pt-1'>Islands</li></Link>
             <Link to="/semiverticals">  <li className='pt-1'>Semi Verticals</li></Link>
             <Link to="/moresolutions">  <li className='pt-1'>More Solutions</li></Link>
             <Link to="/intelligent">  <li className='pt-1'>Intelligent Solutions</li></Link>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="text-center sm:text-left">
            <h3 className="text-xl font-bold mb-4">Contacts</h3>
            <ul className="space-y-2 text-white">
              <li>Email: <a href="mailto:FGomes@dsgo.ca" className="hover:text-gray-400">FGomes@dsgo.ca</a></li>
              <li>Phone: <a href="tel:+16474687434" className="hover:text-gray-400">+1 647 468 7434</a></li>
              <li>Address: Woodbridge, ON, L4L5W5</li>
            </ul>

             <div className=" bg-transparent opacity-80">
                    <ul className="flex  justify-center gap-6 items-center mt-6">
                      <li>
                        <a
                          target="_blank"
                         rel="noopener noreferrer"
                        href="https://www.facebook.com/" className="hover:underline">
                          <FontAwesomeIcon icon={faFacebook} className="w-8 h-8 text-white" />
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                         rel="noopener noreferrer"
                        href="https://www.instagram.com/" className="hover:underline">
                          <FontAwesomeIcon icon={faInstagram} className="w-8 h-8 text-white" />
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
  rel="noopener noreferrer"
                        href="https://www.linkedin.com/" className="hover:underline">
                          <FontAwesomeIcon icon={faLinkedinIn} className="w-8 h-8 text-white" />
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
  rel="noopener noreferrer"
                        href="#x" className="hover:underline">
                          <FontAwesomeIcon icon={faXTwitter} className="w-8 h-8 text-white" />
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
  rel="noopener noreferrer"
                        href="mailto:FGomes@dsgo.ca" className="hover:underline">
                          <FontAwesomeIcon icon={faEnvelope} className="w-10 h-8 text-white" />
                        </a>
                      </li>
                    </ul>
                  </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-12 border-t border-white pt-6 text-center justify-center flex gap-10">
          <p className="text-white text-sm">&copy; 2025 Creative 7 Inc. Canada.</p>
          <p className="text-white text-sm">All Rights Reserved </p>
        </div>

    </footer>
  );
};

export default Footer;




// import React from 'react';

// const Footer = () => {
//   return (
//     <footer className="bg-[#53707A] text-white py-8">
//       <div className="container mx-auto px-6 lg:px-12">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">

//           {/* Business Areas Section */}
//           <div className="text-center sm:text-left">
//             <h3 className="text-xl font-bold mb-4">Business Areas</h3>
//             <ul className="space-y-2 text-white">
//               <li>Coffee Shop</li>
//               <li>Bakery & Pastry</li>
//               <li>Butchery & Charcuterie</li>
//               <li>Supermarket & C-Stores</li>
//               <li>Take-Away</li>
//               <li>Restaurant & Self-Service</li>
//               <li>Chocolate</li>
//               <li>Ice Cream</li>
//               <li>Sushi</li>
//               <li>Fish & Seafood</li>
//               <li>Professional Kitchens</li>
//             </ul>
//           </div>

//           {/* Models Section */}
//           <div className="text-center sm:text-left">
//             <h3 className="text-xl font-bold mb-4">Models</h3>
//             <ul className="space-y-2 text-white">
//               <li>Display Cases & Serve-Overs</li>
//               <li>Multidecks</li>
//               <li>Bar Counters</li>
//               <li>Cabinets</li>
//               <li>Storage Counters</li>
//               <li>Islands</li>
//               <li>Semi-Verticals</li>
//               <li>More Solutions</li>
//               <li>Intelligent Solutions</li>
//             </ul>
//           </div>

//           {/* About Us Section */}
//           <div className="text-center sm:text-left">
//             <h3 className="text-xl font-bold mb-4">About Us</h3>
//             <ul className="space-y-2 text-white">
//               <li>Timeline</li>
//               <li>Sustainability</li>
//               <li>Projects</li>
//               <li>FAQ</li>
//               <li>Disclaimer</li>
//               <li>Complaint Book</li>
//               <li>Channel Report</li>
//             </ul>
//           </div>

//           {/* Communication Section */}
//           <div className="text-center sm:text-left">
//             <h3 className="text-xl font-bold mb-4">Communication</h3>
//             <ul className="space-y-2 text-white">
//               <li>News</li>
//               <li>Fairs & Events</li>
//               <li>Case Studies</li>
//               <li>COOL Magazine</li>
//               <li>Recruitment</li>
//             </ul>
//           </div>

//           {/* Contact Section */}
//           <div className="text-center sm:text-left">
//             <h3 className="text-xl font-bold mb-4">Contacts</h3>
//             <ul className="space-y-2 text-white">
//               <li>Email: <a href="mailto:info@example.com" className="hover:text-gray-400">info@example.com</a></li>
//               <li>Phone: <a href="tel:+1234567890" className="hover:text-gray-400">+123 456 7890</a></li>
//               <li>Address: 123 Street, City, Country</li>
//             </ul>
//           </div>
//         </div>

//         {/* Footer Bottom */}
//         <div className="mt-12 border-t border-gray-700 pt-6 text-center">
//           <p className="text-gray-400 text-sm">&copy; 2025 Alif Dynamics Inc. Canada All Rights Reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
